<script setup lang="ts">
  import { Environment } from '~/types/Environments'
  import { DialogWrapper } from 'vue3-promise-dialog'
  import { cn } from '~/utils/style'

  useHead({
    titleTemplate: (titleChunk) =>
      titleChunk ? `${titleChunk} | GMP+ International` : 'GMP+ International',
  })

  const { hostname } = useRequestURL()

  const gtm = useGtm()
  if (hostname === Environment.production) {
    gtm?.enable()
  }

  const { locale } = useI18n()

  const defaultLocale = useLocalStorage<'en' | 'nl' | 'de'>('locale', locale.value)
  onMounted(() => {
    // setLocale(defaultLocale.value)
  })

  watch(locale, (value) => {
    defaultLocale.value = value
  })
  const authStore = useAuthStore()
  useFavourites()
  const ENABLE_TERM_OF_USE_POPUP = true // TODO: a feature flag to enable/disable feature between environments
  const showTermOfUsePopup = computed(() => {
    return ENABLE_TERM_OF_USE_POPUP && !authStore.agreementAccepted
  })
</script>

<template>
  <div :class="cn(showTermOfUsePopup ? 'opacity-50 blur' : '')">
    <div>
      <NuxtLoadingIndicator
        color="repeating-linear-gradient(to right,#38B769 0%,#1A85C7 50%,var(--dp-primary-color) 100%)"
      />
      <NuxtLayout>
        <NuxtPage />
        <CommandPalette />
      </NuxtLayout>
      <DialogWrapper />
      
      <TermOfUseDialog :model-value="showTermOfUsePopup" />
    </div>
  </div>
</template>

<style>
  .layout-enter-active,
  .layout-leave-active {
    transition: all 0.1s;
  }

  .layout-enter-from,
  .layout-leave-to {
    opacity: 0;
    filter: blur(1rem);
  }

  @page {
    size: landscape;
    margin: 12px 48px 12px 48px;
  }
</style>
